import Vue from "vue";
import VueTags from "vue-tags";
Vue.component("input-tags", VueTags);